import { Stack } from '@mui/material';
import { useCreditsData } from '../hooks';
import { useTableCheckIds } from '../store';

export const UserMapping = () => {
  const data = useCreditsData();
  const checked = useTableCheckIds();

  if (checked.length <= 1) return;

  return (
    <Stack gap={1}>
      {data.map((credit) =>
        checked.includes(credit.id) ? (
          <Stack direction="row" gap={2} alignItems="center">
            <svg
              width="34"
              height="33"
              viewBox="0 0 34 33"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M33.5 16.5C33.5 21.5175 31.2605 26.013 27.725 29.04C24.7389 31.6006 20.9336 33.0056 17 33C12.905 33 9.15951 31.509 6.27501 29.04C4.46233 27.4922 3.00721 25.5693 2.01015 23.4043C1.01309 21.2393 0.49785 18.8836 0.500007 16.5C0.500007 7.3875 7.88751 0 17 0C26.1125 0 33.5 7.3875 33.5 16.5ZM23 11.25C23 9.6587 22.3679 8.13258 21.2426 7.00736C20.1174 5.88214 18.5913 5.25 17 5.25C15.4087 5.25 13.8826 5.88214 12.7574 7.00736C11.6321 8.13258 11 9.6587 11 11.25C11 12.8413 11.6321 14.3674 12.7574 15.4926C13.8826 16.6179 15.4087 17.25 17 17.25C18.5913 17.25 20.1174 16.6179 21.2426 15.4926C22.3679 14.3674 23 12.8413 23 11.25ZM26.75 25.8375V25.5C26.75 23.9087 26.1179 22.3826 24.9926 21.2574C23.8674 20.1321 22.3413 19.5 20.75 19.5H13.25C11.6587 19.5 10.1326 20.1321 9.00737 21.2574C7.88215 22.3826 7.25001 23.9087 7.25001 25.5V25.8375C7.56001 26.1605 7.88501 26.468 8.22501 26.76C10.6677 28.8559 13.7814 30.0056 17 30C18.8225 30.0035 20.6266 29.6363 22.3028 28.9207C23.9789 28.2051 25.492 27.1561 26.75 25.8375Z"
                fill="#CBCACA"
              />
            </svg>
            {credit.lastName}, {credit.firstName}
          </Stack>
        ) : (
          ''
        ),
      )}
    </Stack>
  );
};
